define("calendar/components/calendar/full-calendar", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@ember/object/computed", "@ember/runloop", "@ember/service", "@ember/utils", "@fullcalendar/core", "@fullcalendar/core/locales/de", "@fullcalendar/core/locales/es", "@fullcalendar/core/locales/fr", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "ember-concurrency-ts", "moment", "perfect-scrollbar", "calendar/utils/markupBuilders", "later/services/calendar/markup", "later/services/errors", "later/utils/constants", "later/utils/translation-paths"], function (_exports, _component, _templateFactory, _object, _computed, _runloop, _service, _utils, _core, _de, _es, _fr, _component2, _tracking, _emberConcurrency, _emberConcurrencyTs, _moment, _perfectScrollbar, _markupBuilders, _markup, _errors, _constants, _translationPaths) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _addNonNoteEvents, _addParentClasses, _createPost, _createCarouselPost, _destroyTimeSlot, _displayCarouselWarning, _displayMonthViewNotes, _generatePostContent, _generateTimeSlotContent, _getDroppedEventDateTime, _getDateWithTimeZone, _handleDrop, _handleRightClick, _isValidTimeSlotTarget, _setEventsDisplay, _trackLastClick, _transitionToMultiPostCreation, _transitionToPostCreation, _turnOnCalendarNotes, _updateEventDisplay, _updateNoteTime, _trackSchedulingPost, _updateTimeSlotTime, _updateBttp;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/object/computed",0,"@ember/runloop",0,"@ember/service",0,"@ember/utils",0,"@fullcalendar/core",0,"@fullcalendar/core/locales/de",0,"@fullcalendar/core/locales/es",0,"@fullcalendar/core/locales/fr",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"ember-concurrency-ts",0,"moment",0,"perfect-scrollbar",0,"calendar/utils/markupBuilders",0,"later/services/calendar/markup",0,"later/services/errors",0,"later/utils/constants",0,"later/utils/translation-paths"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }

  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{#if this.showTiktokRefreshModal}}
    <Shared::Credentials::TiktokRefresh
      @closeTiktokRefreshModal={{this.closeTiktokRefreshModal}}
      @tiktokProfile={{this.selectedTiktokProfile}}
    />
  {{/if}}
  {{#if this.showBttpPromoModal}}
    <Calendar::BttpPromo @close={{set this "showBttpPromoModal" false}} @viewCalendarSettings={{@viewCalendarSettings}} />
  {{/if}}
  {{#if @showCalendarSettings}}
    <Calendar::Settings
      @closeModal={{@closeCalendarSettings}}
      @showCalendarNotes={{this.showCalendarNotes}}
      @toggleCalendarNotes={{this.toggleCalendarNotes}}
    />
  {{/if}}
  <div
    class={{if this.permissions.showInstagramStories "cCA--calendar--instagram"}}
    data-test-id="full-calendar"
    {{did-insert this.createCalendar}}
    {{did-update
      this.updateCalendar
      this.currentGroup
      this.profiles
      this.locale.primaryLocale
      this.multipleProfilesSelected
    }}
    {{did-update this.updateEvents this.cachedData this.permissions}}
    {{on "dblclick" this.handleDoubleClick}}
  >
    <div class="cCA--calendar" id="calendar">
      {{#if this.shouldShowSocialConnectModal}}
        <Calendar::ConnectSocial @close={{this.closeConnectSocialModal}} />
      {{/if}}
    </div>
  
    {{#if this.permissions.showInstagramStories}}
      <Calendar::ScheduledStories @targetDate={{@targetDate}} @timelineStories={{@timelineStories}} />
    {{/if}}
  
    <Calendar::ContextMenu
      @createNewCalendarNote={{this.createNewCalendarNote}}
      @hideContextMenu={{this.hideContextMenu}}
      @left={{this.menuLeft}}
      @selectedProfiles={{@selectedSocialProfiles}}
      @top={{this.menuTop}}
      @visible={{this.displayContextMenu}}
    />
  </div>
  
  {{#if this.isOnMonthView}}
    {{#each this.monthViewNotes as |monthViewNotes|}}
      {{! monthViewNotes is a tuple containing [date string, note events array] }}
      {{#let (hash date=(get monthViewNotes "0") notes=(get monthViewNotes "1")) as |notesByDate|}}
        <Shared::Ui::EmberDrop
          @constrainToScrollParent={{false}}
          @constrainToWindow={{true}}
          @contentSelector=".e--collect--drop"
          @hoverOpenDelay={{300}}
          @openOn="click"
          @position="bottom right"
          @target={{concat ".fc-note-" (moment-format notesByDate.date this.dateFormat)}}
          @tetherOptions="25px 0"
          as |emberDrop|
        >
  
          <div class="o--dropWrapper cCA--dropDown cCA--dropDown--lg e--collect--drop">
            <div class="o--dropBody--scroll">
              <p class="u--text--bold u--m__0">{{moment-format notesByDate.date "ddd, MMM DD"}}</p>
              <p class="u--text--sm u--text--light u--m__0">
                {{notesByDate.notes.length}}
                {{t "calendar_notes.notes" count=notesByDate.notes.length}}
              </p>
              <ul class="cCA--dropList">
                {{#each notesByDate.notes as |note|}}
                  <li class="cCA--dropList__li">
                    <span class="cCA--dropList__icon">
                      {{svg-jar "notes" class="o--icon--xs"}}
                    </span>
                    <p class="cCA--dropList__text">{{note.noteSummary}}</p>
                    <button
                      class="o--btn--block o--btn--sm o--btn--outline"
                      type="button"
                      {{on "click" (fn this.editCalendarNote note.id emberDrop.closeAction)}}
                    >
                      {{t "calendar_notes.view_note"}}
                    </button>
                  </li>
                {{/each}}
              </ul>
            </div>
          </div>
        </Shared::Ui::EmberDrop>
      {{/let}}
    {{/each}}
  {{/if}}
  
  {{#if this.shouldShowNotesTrialStartModal}}
    <Calendar::NotesTrialStart @closeModal={{this.closeNotesTrialStartModal}} />
  {{/if}}
  */
  {
    "id": "TVQb3rZ2",
    "block": "[[[41,[30,0,[\"showTiktokRefreshModal\"]],[[[1,\"  \"],[8,[39,1],null,[[\"@closeTiktokRefreshModal\",\"@tiktokProfile\"],[[30,0,[\"closeTiktokRefreshModal\"]],[30,0,[\"selectedTiktokProfile\"]]]],null],[1,\"\\n\"]],[]],null],[41,[30,0,[\"showBttpPromoModal\"]],[[[1,\"  \"],[8,[39,2],null,[[\"@close\",\"@viewCalendarSettings\"],[[28,[37,3],[[30,0],\"showBttpPromoModal\",false],null],[30,1]]],null],[1,\"\\n\"]],[]],null],[41,[30,2],[[[1,\"  \"],[8,[39,4],null,[[\"@closeModal\",\"@showCalendarNotes\",\"@toggleCalendarNotes\"],[[30,3],[30,0,[\"showCalendarNotes\"]],[30,0,[\"toggleCalendarNotes\"]]]],null],[1,\"\\n\"]],[]],null],[11,0],[16,0,[52,[30,0,[\"permissions\",\"showInstagramStories\"]],\"cCA--calendar--instagram\"]],[24,\"data-test-id\",\"full-calendar\"],[4,[38,5],[[30,0,[\"createCalendar\"]]],null],[4,[38,6],[[30,0,[\"updateCalendar\"]],[30,0,[\"currentGroup\"]],[30,0,[\"profiles\"]],[30,0,[\"locale\",\"primaryLocale\"]],[30,0,[\"multipleProfilesSelected\"]]],null],[4,[38,6],[[30,0,[\"updateEvents\"]],[30,0,[\"cachedData\"]],[30,0,[\"permissions\"]]],null],[4,[38,7],[\"dblclick\",[30,0,[\"handleDoubleClick\"]]],null],[12],[1,\"\\n  \"],[10,0],[14,0,\"cCA--calendar\"],[14,1,\"calendar\"],[12],[1,\"\\n\"],[41,[30,0,[\"shouldShowSocialConnectModal\"]],[[[1,\"      \"],[8,[39,8],null,[[\"@close\"],[[30,0,[\"closeConnectSocialModal\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"permissions\",\"showInstagramStories\"]],[[[1,\"    \"],[8,[39,9],null,[[\"@targetDate\",\"@timelineStories\"],[[30,4],[30,5]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n  \"],[8,[39,10],null,[[\"@createNewCalendarNote\",\"@hideContextMenu\",\"@left\",\"@selectedProfiles\",\"@top\",\"@visible\"],[[30,0,[\"createNewCalendarNote\"]],[30,0,[\"hideContextMenu\"]],[30,0,[\"menuLeft\"]],[30,6],[30,0,[\"menuTop\"]],[30,0,[\"displayContextMenu\"]]]],null],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"isOnMonthView\"]],[[[42,[28,[37,12],[[28,[37,12],[[30,0,[\"monthViewNotes\"]]],null]],null],null,[[[44,[[28,[37,14],null,[[\"date\",\"notes\"],[[28,[37,15],[[30,7],\"0\"],null],[28,[37,15],[[30,7],\"1\"],null]]]]],[[[1,\"      \"],[8,[39,16],null,[[\"@constrainToScrollParent\",\"@constrainToWindow\",\"@contentSelector\",\"@hoverOpenDelay\",\"@openOn\",\"@position\",\"@target\",\"@tetherOptions\"],[false,true,\".e--collect--drop\",300,\"click\",\"bottom right\",[28,[37,17],[\".fc-note-\",[28,[37,18],[[30,8,[\"date\"]],[30,0,[\"dateFormat\"]]],null]],null],\"25px 0\"]],[[\"default\"],[[[[1,\"\\n\\n        \"],[10,0],[14,0,\"o--dropWrapper cCA--dropDown cCA--dropDown--lg e--collect--drop\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"o--dropBody--scroll\"],[12],[1,\"\\n            \"],[10,2],[14,0,\"u--text--bold u--m__0\"],[12],[1,[28,[35,18],[[30,8,[\"date\"]],\"ddd, MMM DD\"],null]],[13],[1,\"\\n            \"],[10,2],[14,0,\"u--text--sm u--text--light u--m__0\"],[12],[1,\"\\n              \"],[1,[30,8,[\"notes\",\"length\"]]],[1,\"\\n              \"],[1,[28,[35,19],[\"calendar_notes.notes\"],[[\"count\"],[[30,8,[\"notes\",\"length\"]]]]]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,\"ul\"],[14,0,\"cCA--dropList\"],[12],[1,\"\\n\"],[42,[28,[37,12],[[28,[37,12],[[30,8,[\"notes\"]]],null]],null],null,[[[1,\"                \"],[10,\"li\"],[14,0,\"cCA--dropList__li\"],[12],[1,\"\\n                  \"],[10,1],[14,0,\"cCA--dropList__icon\"],[12],[1,\"\\n                    \"],[1,[28,[35,20],[\"notes\"],[[\"class\"],[\"o--icon--xs\"]]]],[1,\"\\n                  \"],[13],[1,\"\\n                  \"],[10,2],[14,0,\"cCA--dropList__text\"],[12],[1,[30,10,[\"noteSummary\"]]],[13],[1,\"\\n                  \"],[11,\"button\"],[24,0,\"o--btn--block o--btn--sm o--btn--outline\"],[24,4,\"button\"],[4,[38,7],[\"click\",[28,[37,21],[[30,0,[\"editCalendarNote\"]],[30,10,[\"id\"]],[30,9,[\"closeAction\"]]],null]],null],[12],[1,\"\\n                    \"],[1,[28,[35,19],[\"calendar_notes.view_note\"],null]],[1,\"\\n                  \"],[13],[1,\"\\n                \"],[13],[1,\"\\n\"]],[10]],null],[1,\"            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[9]]]]],[1,\"\\n\"]],[8]]]],[7]],null]],[]],null],[1,\"\\n\"],[41,[30,0,[\"shouldShowNotesTrialStartModal\"]],[[[1,\"  \"],[8,[39,22],null,[[\"@closeModal\"],[[30,0,[\"closeNotesTrialStartModal\"]]]],null],[1,\"\\n\"]],[]],null]],[\"@viewCalendarSettings\",\"@showCalendarSettings\",\"@closeCalendarSettings\",\"@targetDate\",\"@timelineStories\",\"@selectedSocialProfiles\",\"monthViewNotes\",\"notesByDate\",\"emberDrop\",\"note\"],false,[\"if\",\"shared/credentials/tiktok-refresh\",\"calendar/bttp-promo\",\"set\",\"calendar/settings\",\"did-insert\",\"did-update\",\"on\",\"calendar/connect-social\",\"calendar/scheduled-stories\",\"calendar/context-menu\",\"each\",\"-track-array\",\"let\",\"hash\",\"get\",\"shared/ui/ember-drop\",\"concat\",\"moment-format\",\"t\",\"svg-jar\",\"fn\",\"calendar/notes-trial-start\"]]",
    "moduleName": "calendar/components/calendar/full-calendar.hbs",
    "isStrictMode": false
  });

  const {
    NOTE,
    POST,
    BTTP,
    BTTP_PROMO,
    TIME_SLOT
  } = _constants.CALENDAR_EVENT_TYPES;
  const {
    DEFAULT
  } = _constants.CALENDAR_TYPES;
  const {
    MONTH,
    WEEK
  } = _constants.CALENDAR_VIEW_TYPES;
  const CALENDAR_NOTE_STATES = {
    ON: 'on',
    OFF: 'off'
  };
  let FullCalendarComponent = (_dec = (0, _service.inject)('calendar/bttp'), _dec2 = (0, _service.inject)('calendar/config'), _dec3 = (0, _service.inject)('calendar/events'), _dec4 = (0, _service.inject)('calendar/markup'), _dec5 = (0, _service.inject)('note'), _dec6 = (0, _service.inject)('schedule/calendar/time-slot'), _dec7 = (0, _service.inject)('schedule/post'), _dec8 = (0, _computed.readOnly)('auth.currentAccount'), _dec9 = (0, _computed.readOnly)('account.canCarousel'), _dec10 = (0, _computed.readOnly)('account.canInstagramStories'), _dec11 = (0, _computed.readOnly)('calendarConfig.calendarView'), _dec12 = (0, _computed.readOnly)('account.canCalendarNotes'), _dec13 = (0, _computed.readOnly)('selectedSocialProfiles.profiles'), _dec14 = (0, _computed.readOnly)('selectedSocialProfiles.firstProfile'), _dec15 = (0, _computed.readOnly)('selectedSocialProfiles.hasMultipleSelected'), _dec16 = (0, _computed.readOnly)('auth.currentGroup'), _dec17 = (0, _computed.readOnly)('userConfig.currentTimeZone.identifier'), (_class = (_addNonNoteEvents = /*#__PURE__*/new WeakSet(), _addParentClasses = /*#__PURE__*/new WeakSet(), _createPost = /*#__PURE__*/new WeakSet(), _createCarouselPost = /*#__PURE__*/new WeakSet(), _destroyTimeSlot = /*#__PURE__*/new WeakSet(), _displayCarouselWarning = /*#__PURE__*/new WeakSet(), _displayMonthViewNotes = /*#__PURE__*/new WeakSet(), _generatePostContent = /*#__PURE__*/new WeakSet(), _generateTimeSlotContent = /*#__PURE__*/new WeakSet(), _getDroppedEventDateTime = /*#__PURE__*/new WeakSet(), _getDateWithTimeZone = /*#__PURE__*/new WeakSet(), _handleDrop = /*#__PURE__*/new WeakSet(), _handleRightClick = /*#__PURE__*/new WeakSet(), _isValidTimeSlotTarget = /*#__PURE__*/new WeakSet(), _setEventsDisplay = /*#__PURE__*/new WeakSet(), _trackLastClick = /*#__PURE__*/new WeakSet(), _transitionToMultiPostCreation = /*#__PURE__*/new WeakSet(), _transitionToPostCreation = /*#__PURE__*/new WeakSet(), _turnOnCalendarNotes = /*#__PURE__*/new WeakSet(), _updateEventDisplay = /*#__PURE__*/new WeakSet(), _updateNoteTime = /*#__PURE__*/new WeakSet(), _trackSchedulingPost = /*#__PURE__*/new WeakSet(), _updateTimeSlotTime = /*#__PURE__*/new WeakSet(), _updateBttp = /*#__PURE__*/new WeakSet(), class FullCalendarComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);

      _classPrivateMethodInitSpec(this, _updateBttp);

      _classPrivateMethodInitSpec(this, _updateTimeSlotTime);

      _classPrivateMethodInitSpec(this, _trackSchedulingPost);

      _classPrivateMethodInitSpec(this, _updateNoteTime);

      _classPrivateMethodInitSpec(this, _updateEventDisplay);

      _classPrivateMethodInitSpec(this, _turnOnCalendarNotes);

      _classPrivateMethodInitSpec(this, _transitionToPostCreation);

      _classPrivateMethodInitSpec(this, _transitionToMultiPostCreation);

      _classPrivateMethodInitSpec(this, _trackLastClick);

      _classPrivateMethodInitSpec(this, _setEventsDisplay);

      _classPrivateMethodInitSpec(this, _isValidTimeSlotTarget);

      _classPrivateMethodInitSpec(this, _handleRightClick);

      _classPrivateMethodInitSpec(this, _handleDrop);

      _classPrivateMethodInitSpec(this, _getDateWithTimeZone);

      _classPrivateMethodInitSpec(this, _getDroppedEventDateTime);

      _classPrivateMethodInitSpec(this, _generateTimeSlotContent);

      _classPrivateMethodInitSpec(this, _generatePostContent);

      _classPrivateMethodInitSpec(this, _displayMonthViewNotes);

      _classPrivateMethodInitSpec(this, _displayCarouselWarning);

      _classPrivateMethodInitSpec(this, _destroyTimeSlot);

      _classPrivateMethodInitSpec(this, _createCarouselPost);

      _classPrivateMethodInitSpec(this, _createPost);

      _classPrivateMethodInitSpec(this, _addParentClasses);

      _classPrivateMethodInitSpec(this, _addNonNoteEvents);

      _initializerDefineProperty(this, "alerts", _descriptor, this);

      _initializerDefineProperty(this, "auth", _descriptor2, this);

      _initializerDefineProperty(this, "bttp", _descriptor3, this);

      _initializerDefineProperty(this, "errors", _descriptor4, this);

      _initializerDefineProperty(this, "cache", _descriptor5, this);

      _initializerDefineProperty(this, "intl", _descriptor6, this);

      _initializerDefineProperty(this, "onboarding", _descriptor7, this);

      _initializerDefineProperty(this, "locale", _descriptor8, this);

      _initializerDefineProperty(this, "router", _descriptor9, this);

      _initializerDefineProperty(this, "calendarConfig", _descriptor10, this);

      _initializerDefineProperty(this, "calendarEvents", _descriptor11, this);

      _initializerDefineProperty(this, "calendarMarkup", _descriptor12, this);

      _initializerDefineProperty(this, "calendarNote", _descriptor13, this);

      _initializerDefineProperty(this, "calendarTimeSlot", _descriptor14, this);

      _initializerDefineProperty(this, "schedulePost", _descriptor15, this);

      _initializerDefineProperty(this, "segment", _descriptor16, this);

      _initializerDefineProperty(this, "selectedSocialProfiles", _descriptor17, this);

      _initializerDefineProperty(this, "store", _descriptor18, this);

      _initializerDefineProperty(this, "subscriptions", _descriptor19, this);

      _initializerDefineProperty(this, "userConfig", _descriptor20, this);

      _initializerDefineProperty(this, "displayContextMenu", _descriptor21, this);

      _initializerDefineProperty(this, "menuLeft", _descriptor22, this);

      _initializerDefineProperty(this, "menuTop", _descriptor23, this);

      _initializerDefineProperty(this, "selectedNoteDate", _descriptor24, this);

      _initializerDefineProperty(this, "notesByDate", _descriptor25, this);

      _initializerDefineProperty(this, "selectedTiktokProfile", _descriptor26, this);

      _initializerDefineProperty(this, "showBttpPromoModal", _descriptor27, this);

      _initializerDefineProperty(this, "showCalendarNotes", _descriptor28, this);

      _initializerDefineProperty(this, "showConnectSocialModal", _descriptor29, this);

      _initializerDefineProperty(this, "showTiktokRefreshModal", _descriptor30, this);

      _initializerDefineProperty(this, "shouldShowNotesTrialStartModal", _descriptor31, this);

      _defineProperty(this, "calendarNotesCacheKey", 'showCalendarNotes');

      _defineProperty(this, "dateFormat", 'YYYY-MM-DD');

      _defineProperty(this, "lastClickInfo", null);

      _initializerDefineProperty(this, "account", _descriptor32, this);

      _initializerDefineProperty(this, "canCarousel", _descriptor33, this);

      _initializerDefineProperty(this, "canInstagramStories", _descriptor34, this);

      _initializerDefineProperty(this, "calendarView", _descriptor35, this);

      _initializerDefineProperty(this, "canCalendarNotes", _descriptor36, this);

      _initializerDefineProperty(this, "profiles", _descriptor37, this);

      _initializerDefineProperty(this, "socialProfile", _descriptor38, this);

      _initializerDefineProperty(this, "multipleProfilesSelected", _descriptor39, this);

      _initializerDefineProperty(this, "currentGroup", _descriptor40, this);

      _initializerDefineProperty(this, "timeZoneIdentifier", _descriptor41, this);

      const showCalendarNotesCachedValue = this.cache.retrieve(this.calendarNotesCacheKey);

      if (typeof showCalendarNotesCachedValue === 'boolean') {
        this.showCalendarNotes = showCalendarNotesCachedValue;
      }
    } // Note: Calendar events are updated based on this object changing


    get cachedData() {
      return { ...(this.permissions.showBttp && {
          cacheBttpTimeSlots: this.bttp.report?.timeSlots
        }),
        cachePosts: this.args.posts,
        cacheNotes: this.args.notes,
        cacheTimeSlots: !this.multipleProfilesSelected && this.socialProfile ? this.userTimeSlots : [],
        cacheBttpPromoState: this.bttp.shouldShowBttpDiscovery
      };
    }

    get customButtons() {
      // Note: Display preview and stories buttons if only an instagram profile is selected
      const displayAdditionalButtons = this.isInstagram && !this.multipleProfilesSelected;
      const buttons = {
        timezoneButton: {
          text: this.timeZoneIdentifier
        },
        calendarSettings: {
          icon: ' fc-icon-settings qa--calendar_settings_btn',
          click: () => this.args.viewCalendarSettings()
        },
        ...(this.account.rolloutDraftPosts && {
          draftButton: {
            text: this.intl.t('calendar.views.drafts'),
            click: () => this.router.transitionTo('cluster.schedule.drafts', {
              queryParams: this.router.currentRoute.queryParams
            })
          }
        })
      };
      const additionalButtons = {
        previewButton: {
          text: this.intl.t('calendar.views.preview'),
          click: () => this.router.transitionTo('cluster.schedule.preview-grid')
        },
        storiesButton: {
          text: this.intl.t('calendar.views.stories'),
          click: () => this.router.transitionTo('cluster.schedule.stories')
        }
      };
      return displayAdditionalButtons ? { ...buttons,
        ...additionalButtons
      } : buttons;
    }

    get fullCalendar() {
      return this.calendarConfig.fullCalendar;
    }

    get hasNoSocialProfile() {
      return (0, _utils.isEmpty)(this.auth.currentGroup.socialProfiles);
    }

    get isInstagram() {
      return this.socialProfile?.isInstagram;
    }

    get isOnMonthView() {
      return this.calendarView === MONTH;
    }

    get lastDay() {
      const {
        currentFirstDay
      } = this.auth;
      return currentFirstDay ? (currentFirstDay + 6) % 7 : undefined;
    }

    get monthViewNotes() {
      return Object.entries(this.notesByDate);
    }

    get permissions() {
      return {
        showBttp: this.bttp.shouldShow,
        showCalendarNotes: this.shouldShowCalendarNotes,
        showInstagramStories: this.canInstagramStories && !this.isOnMonthView && this.isInstagram && !this.multipleProfilesSelected,
        allowDraftPosts: true
      };
    }

    get shouldShowSocialConnectModal() {
      return this.showConnectSocialModal && this.hasNoSocialProfile && this.auth.currentUserModel.isAccountOwner && !this.onboarding.shouldShowSocialConnectOnboarding;
    } // Note: The time-slots passed in from the social-profile model are occasionally still in an unpersisted state
    // which causes issues when updating (due to non-existent ids)


    get userTimeSlots() {
      return this.socialProfile?.userTimeSlots?.filter(timeslot => timeslot.id) || [];
    }

    get shouldShowCalendarNotes() {
      return this.showCalendarNotes && this.canCalendarNotes;
    }

    get socialProfilesSelectedForScheduling() {
      return this.selectedSocialProfiles.profiles.map(profile => profile.accountType);
    }

    closeConnectSocialModal() {
      this.segment.track('dismissed-social-connect-modal');
      this.showConnectSocialModal = false;
    }

    async createCalendar() {
      // Note: const self = this is required for createCalendar hooks
      // eslint-disable-next-line
      const self = this;
      self.calendarConfig.calendarType = DEFAULT;
      this.showConnectSocialModal = true;
      const calendarEl = document.getElementById('calendar');

      if (!calendarEl) {
        return this.errors.log('FullCalendar: No calendar element found', {}, _errors.ErrorSeverity.Critical);
      }

      const calendar = new _core.Calendar(calendarEl, { ...this.calendarConfig.commonConfig,
        customButtons: self.customButtons,
        dateClick: info => {
          _classPrivateMethodGet(this, _trackLastClick, _trackLastClick2).call(this, info);

          _classPrivateMethodGet(this, _handleRightClick, _handleRightClick2).call(this, info);
        },
        defaultTimedEventDuration: this.calendarEvents.defaultTimedEventDuration,
        droppable: true,
        // Note: Overridden on a per event basis
        editable: true,
        eventDurationEditable: true,
        eventResizableFromStart: false,
        eventStartEditable: true,
        eventTimeFormat: {
          hour12: true,
          hour: 'numeric',
          minute: '2-digit',
          meridiem: false
        },
        firstDay: this.auth.currentFirstDay ?? undefined,
        dayMaxEventRows: true,
        initialDate: this.calendarConfig.targetDateObject(this.args.targetDate),
        initialView: this.calendarConfig.calendarView,
        locales: [_de.default, _es.default, _fr.default],
        locale: this.locale.primaryLocale,
        views: {
          [WEEK]: {
            dayHeaderFormat: {
              weekday: 'short',
              day: 'numeric'
            }
          },
          [MONTH]: {
            // Note: Removed dayHeaderFormat as per this open issue: https://github.com/fullcalendar/fullcalendar/issues/5854
            dayMaxEvents: 6
          }
        },

        // Note: Add hover class to note event element
        eventMouseEnter(_ref) {
          let {
            event,
            el
          } = _ref;

          if (event.extendedProps.eventType === NOTE) {
            const noteEventStartDay = event.extendedProps.startDay;
            el.querySelector('.fc-note')?.classList.add('fc-event_hover');

            if (noteEventStartDay === self.lastDay) {
              el.querySelector('.fc-note')?.classList.add('fc-event_hover--last');
            }
          }
        },

        // Note: Remove hover class from note event element
        eventMouseLeave(_ref2) {
          let {
            event,
            el
          } = _ref2;

          if (event.extendedProps.eventType === NOTE) {
            el.querySelector('.fc-note')?.classList.remove('fc-event_hover', 'fc-event_hover--last');
          }
        },

        viewDidMount: _ref3 => {
          let {
            view
          } = _ref3;
          self.calendarConfig.set('calendarView', view.type);
          const scrollContainer = document.querySelector('.fc-scrollgrid-section-body');

          if (!scrollContainer) {
            return this.errors.log('Stories/FullCalendar: No scroll container element found', {}, _errors.ErrorSeverity.Critical);
          }

          new _perfectScrollbar.default(scrollContainer);

          _classPrivateMethodGet(self, _updateEventDisplay, _updateEventDisplay2).call(self);
        },
        // Note: Using fullcalendar's 'eventContent` content injection API to ensure styling isn't lost
        // during the library's internally triggered event changes
        eventContent: _ref4 => {
          let {
            event
          } = _ref4;
          const {
            extendedProps,
            start
          } = event;
          const {
            eventType,
            noteSummary,
            profileColorClass
          } = extendedProps;

          if (eventType === POST) {
            const eventContentWrapper = _classPrivateMethodGet(self, _generatePostContent, _generatePostContent2).call(self, event);

            return {
              domNodes: [eventContentWrapper]
            };
          }

          if (eventType === NOTE) {
            const noteContentContainer = document.createElement('div');
            noteContentContainer.classList.add('fc-note');
            noteContentContainer.innerHTML = _markupBuilders.default.note(self.intl, noteSummary);
            return {
              domNodes: [noteContentContainer]
            };
          }

          if (eventType === BTTP) {
            const bttpContentContainer = document.createElement('div');
            bttpContentContainer.classList.add(`fc-bgevent__${profileColorClass}`, 'fc-bttp');
            bttpContentContainer.innerHTML = _markupBuilders.default.bttpSvg();
            return {
              domNodes: [bttpContentContainer]
            };
          }

          if (eventType === BTTP_PROMO) {
            // Note: Do not display promo if timeslots already exist
            if (self.bttp.report?.timeSlots?.length) {
              return;
            }

            const bttpPromoContentContainer = document.createElement('div');

            const bttpPromoMarkup = _markupBuilders.default.bttpPromo(self.intl);

            bttpPromoContentContainer.classList.add('fc-bttp-promo');
            self.calendarMarkup.insertMarkup(_markup.MarkupInsertionType.Prepend, bttpPromoContentContainer, bttpPromoMarkup);
            return {
              domNodes: [bttpPromoContentContainer]
            };
          }

          if (eventType === TIME_SLOT) {
            const eventContentWrapper = _classPrivateMethodGet(self, _generateTimeSlotContent, _generateTimeSlotContent2).call(self, start);

            return {
              domNodes: [eventContentWrapper]
            };
          }
        },
        eventDidMount: _ref5 => {
          let {
            el,
            event
          } = _ref5;
          const {
            extendedProps: {
              eventType,
              post
            }
          } = event;

          if (eventType === POST) {
            self.schedulePost.confirmThumbnailExists(post);
          }

          _classPrivateMethodGet(self, _addParentClasses, _addParentClasses2).call(self, el, eventType);
        },

        eventClick(info) {
          const {
            jsEvent,
            event
          } = info;
          const {
            extendedProps,
            id
          } = event || {};

          if (!extendedProps) {
            return;
          }

          const target = jsEvent.target;
          const destroyEventClass = 'e--fc-slot-destroy';

          _classPrivateMethodGet(self, _trackLastClick, _trackLastClick2).call(self, info);

          switch (extendedProps.eventType) {
            case BTTP_PROMO:
              self.showBttpPromoModal = true;
              self.segment.track('enable-bttp-intent', {
                social_profile_handle: self.socialProfile.nickname ?? null,
                active_trial: !!self.subscriptions.hasActiveTrial
              });
              break;

            case POST:
              self.args.openEvent(extendedProps.post.id);
              break;

            case NOTE:
              self.calendarNote.transitionToEdit(extendedProps.note.id);
              break;

            case TIME_SLOT:
              if (id && target?.classList.contains(destroyEventClass)) {
                _classPrivateMethodGet(self, _destroyTimeSlot, _destroyTimeSlot2).call(self, id);
              }

              break;
          }
        },

        async eventDrop(_ref6) {
          let {
            event,
            revert
          } = _ref6;
          const {
            extendedProps: {
              eventType,
              post
            },
            start
          } = event;

          if (!start) {
            return self.errors.log('FullCalendar: No start time provided to eventDrop');
          }

          const startTime = _classPrivateMethodGet(self, _getDateWithTimeZone, _getDateWithTimeZone2).call(self, start).unix();

          switch (eventType) {
            case POST:
              if (post.isDraft && !self.permissions.allowDraftPosts) {
                self.alertDraftPostUpgrade();
                revert();
              } else {
                await self.schedulePost.updateTime.perform(event, startTime);
              }

              break;

            case TIME_SLOT:
              _classPrivateMethodGet(self, _updateTimeSlotTime, _updateTimeSlotTime2).call(self, event);

              break;

            case NOTE:
              self.displayContextMenu = false;

              _classPrivateMethodGet(self, _updateNoteTime, _updateNoteTime2).call(self, event);

              break;
          }
        },

        drop(_ref7) {
          let {
            date,
            draggedEl
          } = _ref7;
          // Note: This debounce can likely be removed once drag and drop has been updated (internal/replace-jquery-drag-and-drop)
          (0, _runloop.debounce)(self, _classPrivateMethodGet(self, _handleDrop, _handleDrop2), {
            date,
            draggedEl
          }, 500);
        }

      });
      self.calendarConfig.set('fullCalendar', calendar);
      calendar.render();
      self.calendarMarkup.updateCalendarSettingsButton();

      _classPrivateMethodGet(self, _updateBttp, _updateBttp2).call(self);

      (0, _emberConcurrencyTs.taskFor)(self.calendarConfig.handleWithProgressBar).perform(() => (0, _emberConcurrencyTs.taskFor)(this._updateEvents).perform()); // Note: Remove and add event sources based on new dates, update 'targetDate'

      calendar.on('datesSet', _ref8 => {
        let {
          start,
          end
        } = _ref8;
        return (0, _emberConcurrencyTs.taskFor)(this.calendarConfig.handleWithProgressBar).perform(() => (0, _emberConcurrencyTs.taskFor)(this._handleDateSet).perform(start, end, calendar));
      });
    }

    alertAndDisplayNotes() {
      if (!this.showCalendarNotes) {
        this.alerts.success(this.intl.t('alerts.calendar_notes.turning_on.message'), {
          title: this.intl.t('alerts.calendar_notes.turning_on.title'),
          timeout: 5000
        });
      }

      _classPrivateMethodGet(this, _turnOnCalendarNotes, _turnOnCalendarNotes2).call(this);
    }

    createNewCalendarNote() {
      if (this.canCalendarNotes) {
        this.alertAndDisplayNotes();
        this.calendarNote.create(this.selectedNoteDate);
        this.hideContextMenu();
      } else {
        this.shouldShowNotesTrialStartModal = true;
      }
    }

    closeTiktokRefreshModal() {
      this.showTiktokRefreshModal = false;
    }

    editCalendarNote(id, closeAction) {
      this.calendarNote.transitionToEdit(id);
      closeAction();
    } // Note: If double click target meets criteria, create new user time slot


    handleDoubleClick(_ref9) {
      let {
        srcElement
      } = _ref9;

      if (!this.lastClickInfo || this.hasNoSocialProfile) {
        return;
      }

      const {
        date,
        view
      } = this.lastClickInfo;
      const target = this.lastClickInfo.target;

      const isValidTarget = _classPrivateMethodGet(this, _isValidTimeSlotTarget, _isValidTimeSlotTarget2).call(this, target?.classList) && _classPrivateMethodGet(this, _isValidTimeSlotTarget, _isValidTimeSlotTarget2).call(this, srcElement.classList);

      if (view === WEEK && isValidTarget) {
        (0, _emberConcurrencyTs.taskFor)(this._createNewTimeSlot).perform(date);
      }
    }

    hideContextMenu() {
      this.displayContextMenu = false;
    }

    openTiktokRefreshModal(tiktokProfile) {
      this.selectedTiktokProfile = tiktokProfile;
      this.showTiktokRefreshModal = true;
    }

    toggleCalendarNotes() {
      const {
        ON,
        OFF
      } = CALENDAR_NOTE_STATES;
      const newState = this.showCalendarNotes ? ON : OFF;
      this.showCalendarNotes = !this.showCalendarNotes;
      this.cache.add(this.calendarNotesCacheKey, this.showCalendarNotes, {
        expiry: this.cache.maxExpiryDate(),
        persist: true
      });
      this.segment.track('toggled-show-calendar-notes', {
        new_state: newState
      });
    }

    updateCalendar() {
      (0, _emberConcurrencyTs.taskFor)(this.calendarConfig.handleWithProgressBar).perform(() => {
        _classPrivateMethodGet(this, _updateBttp, _updateBttp2).call(this);

        (0, _emberConcurrencyTs.taskFor)(this._updateHeaderAndEvents).perform();
      });
    }

    updateEvents() {
      (0, _emberConcurrencyTs.taskFor)(this._updateEvents).perform();
    }

    closeNotesTrialStartModal() {
      this.shouldShowNotesTrialStartModal = false;
    }
    /**
     * Show an alert for upgrading plan to one that supports the creation and
     * editing of draft posts.
     */


    alertDraftPostUpgrade() {
      this.alerts.upgrade(this.intl.t('drafts.alerts.upgrade.message'), {
        title: this.intl.t('drafts.alerts.upgrade.title'),
        type: 'info',
        feature: 'draftPosts',
        location: 'draft posts schedule flash message',
        upgradeText: this.intl.t('shared_phrases.upgrade_plan'),
        upgradeQaClassName: 'qa--draftPostsUpsell_upgradePlan_Btn'
      });
    }

    *_createNewTimeSlot(date) {
      if (!this.args.canCreateTimeSlots) {
        return;
      }

      const events = yield (0, _emberConcurrencyTs.taskFor)(this.calendarEvents.getEvents).perform();
      const timeSlotEvents = events.any(event => event.eventType === TIME_SLOT); // Note: If no time slot events exist, open quick scheduling wizard - otherwise create a new time slot

      if (!timeSlotEvents) {
        this.args.showQuickScheduleWizard();
      } else if (this.fullCalendar?.view?.type === WEEK) {
        yield this.calendarTimeSlot.create((0, _moment.default)(date));
      }

      this.updateEvents();
    }

    *_handleDateSet(start, end, calendar) {
      const targetDate = calendar.getDate();
      const formattedDate = (0, _moment.default)(targetDate).valueOf();
      yield (0, _emberConcurrencyTs.taskFor)(this._updateEvents).perform({
        start,
        end
      });
      this.args.updateTargetDate(formattedDate);

      _classPrivateMethodGet(this, _updateEventDisplay, _updateEventDisplay2).call(this);
    }

    *_updateHeaderAndEvents() {
      this.fullCalendar?.setOption('customButtons', this.customButtons);
      this.fullCalendar?.setOption('headerToolbar', this.calendarConfig.headerToolbar);
      yield this.updateEvents();
    } // Note: Update calendar events, events should already be in store from previous calls or createCalendar


    *_updateEvents() {
      let fetchInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.calendarEvents.defaultFetchInfo;
      const {
        fullCalendar
      } = this.calendarConfig;
      const events = yield (0, _emberConcurrencyTs.taskFor)(this.calendarEvents.getEvents).perform(this.cachedData, fetchInfo);
      (0, _emberConcurrencyTs.taskFor)(this.calendarEvents.prefetch).perform(fetchInfo.start);
      this.fullCalendar?.setOption('customButtons', this.customButtons);
      this.fullCalendar?.setOption('locale', this.locale.primaryLocale);
      fullCalendar?.removeAllEvents(); // Note: If on month view, display note events in non-standard format

      if (this.isOnMonthView) {
        const postEvents = events.filter(_ref10 => {
          let {
            eventType
          } = _ref10;
          return eventType === POST;
        });
        const noteEvents = events.filter(_ref11 => {
          let {
            eventType
          } = _ref11;
          return eventType === NOTE;
        });
        yield fullCalendar?.addEventSource(postEvents);

        _classPrivateMethodGet(this, _displayMonthViewNotes, _displayMonthViewNotes2).call(this, noteEvents);
      } else if (!this.isOnMonthView && !this.permissions.showCalendarNotes) {
        _classPrivateMethodGet(this, _addNonNoteEvents, _addNonNoteEvents2).call(this, events);
      } else if (!this.isOnMonthView) {
        yield fullCalendar?.addEventSource(events);
      }
    }

  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "bttp", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "cache", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "onboarding", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "locale", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "calendarConfig", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "calendarEvents", [_dec3], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "calendarMarkup", [_dec4], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "calendarNote", [_dec5], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "calendarTimeSlot", [_dec6], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "schedulePost", [_dec7], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "selectedSocialProfiles", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "userConfig", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "displayContextMenu", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "menuLeft", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "menuTop", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "selectedNoteDate", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "notesByDate", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return {};
    }
  }), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "selectedTiktokProfile", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "showBttpPromoModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "showCalendarNotes", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return true;
    }
  }), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "showConnectSocialModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "showTiktokRefreshModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "shouldShowNotesTrialStartModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "account", [_dec8], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "canCarousel", [_dec9], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "canInstagramStories", [_dec10], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "calendarView", [_dec11], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "canCalendarNotes", [_dec12], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "profiles", [_dec13], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "socialProfile", [_dec14], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "multipleProfilesSelected", [_dec15], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "currentGroup", [_dec16], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor41 = _applyDecoratedDescriptor(_class.prototype, "timeZoneIdentifier", [_dec17], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "closeConnectSocialModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeConnectSocialModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createCalendar", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "createCalendar"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "alertAndDisplayNotes", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "alertAndDisplayNotes"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createNewCalendarNote", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "createNewCalendarNote"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeTiktokRefreshModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeTiktokRefreshModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "editCalendarNote", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "editCalendarNote"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleDoubleClick", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleDoubleClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hideContextMenu", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "hideContextMenu"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openTiktokRefreshModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openTiktokRefreshModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleCalendarNotes", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleCalendarNotes"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateCalendar", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateCalendar"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateEvents", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateEvents"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeNotesTrialStartModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeNotesTrialStartModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_createNewTimeSlot", [_emberConcurrency.task], Object.getOwnPropertyDescriptor(_class.prototype, "_createNewTimeSlot"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_handleDateSet", [_emberConcurrency.task], Object.getOwnPropertyDescriptor(_class.prototype, "_handleDateSet"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_updateHeaderAndEvents", [_emberConcurrency.task], Object.getOwnPropertyDescriptor(_class.prototype, "_updateHeaderAndEvents"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_updateEvents", [_emberConcurrency.keepLatestTask], Object.getOwnPropertyDescriptor(_class.prototype, "_updateEvents"), _class.prototype)), _class));
  _exports.default = FullCalendarComponent;

  async function _addNonNoteEvents2() {
    let events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    const nonNoteEvents = events.filter(_ref12 => {
      let {
        eventType
      } = _ref12;
      return eventType !== NOTE;
    });
    await this.calendarConfig?.fullCalendar?.addEventSource(nonNoteEvents);
  }

  function _addParentClasses2(el, eventType) {
    if (!el.parentElement) {
      return;
    }

    switch (eventType) {
      case POST:
        el.parentElement.classList.add('fc-post-harness');
        break;

      case NOTE:
        el.parentElement.classList.add('fc-note-harness');
        break;

      case BTTP:
        el.parentElement.classList.add('fc-bttp-harness');
        break;

      case BTTP_PROMO:
        el.parentElement.classList.add('fc-bttp-promo-harness');
        break;

      case TIME_SLOT:
        el.parentElement.classList.add('fc-time-slot-harness');
        break;
    }
  }

  function _createPost2(mediaItemId, scheduledTime) {
    const {
      isPinterest,
      isBusiness
    } = this.socialProfile || {};
    const mediaItem = this.store.peekRecord('media-item', mediaItemId);

    if (mediaItem?.isVideo && isPinterest && !isBusiness && this.account.canPinterestVideo) {
      this.args.enablePinterestBusiness();
    } else {
      _classPrivateMethodGet(this, _transitionToPostCreation, _transitionToPostCreation2).call(this, mediaItemId, scheduledTime);
    }
  }

  function _createCarouselPost2(scheduledTime, mediaItemId, selectedAssets) {
    const {
      isInstagram,
      isTiktok
    } = this.socialProfile || {};
    const containsImage = selectedAssets.some(asset => asset.isImage);
    const validCarouselProfile = isInstagram || containsImage && !isTiktok;

    if (this.multipleProfilesSelected) {
      _classPrivateMethodGet(this, _transitionToMultiPostCreation, _transitionToMultiPostCreation2).call(this, mediaItemId, scheduledTime);
    } else if (validCarouselProfile) {
      _classPrivateMethodGet(this, _transitionToPostCreation, _transitionToPostCreation2).call(this, mediaItemId, scheduledTime);
    } else {
      const message = (0, _translationPaths.buildRestrictionsInfoString)(this.socialProfile, 'alerts.posts.carousel');
      this.alerts.warning(this.intl.t(message));
    }
  }

  function _destroyTimeSlot2(id) {
    if ((0, _utils.isNone)(id)) {
      this.errors.log(new Error('Trying to delete timeslot - record has no id'), {
        socialProfileId: this.socialProfile.id
      });
    }

    if (!this.multipleProfilesSelected) {
      this.calendarTimeSlot.delete(id);
    }
  }

  function _displayCarouselWarning2() {
    const upgradeMessage = this.account.canTrialPlan ? this.intl.t('alerts.calendar.cannot_schedule_carousel_free.message_trial') : this.intl.t('alerts.calendar.cannot_schedule_carousel_free.message');
    this.alerts.upgrade(upgradeMessage, {
      title: this.intl.t('alerts.calendar.cannot_schedule_carousel_free.title'),
      type: 'info',
      feature: 'multiPhoto',
      location: 'multi photo schedule flash message',
      upgradeText: this.intl.t('shared_phrases.upgrade_plan'),
      upgradeQaClassName: 'qa--carouselUpsell_upgradePlan_Btn'
    });
  }

  async function _displayMonthViewNotes2(notes) {
    const monthViewElementClass = 'fc-note-month'; // Note: Clear existing note markup

    this.notesByDate = {};
    document.querySelectorAll(`.${monthViewElementClass}`)?.forEach(node => node.remove()); // Note: Group notes by date

    notes.forEach(note => {
      if (!note || !note.start) {
        return;
      }

      const formattedEventDate = (0, _moment.default)(note.start).format(this.dateFormat);
      const dateContainer = document.querySelector(`[data-date="${formattedEventDate}"]`); // Note: If date isn't currently visible on calendar, don't attempt to render note display

      if (!dateContainer) {
        return;
      }

      if (!this.notesByDate[formattedEventDate]) {
        this.notesByDate[formattedEventDate] = [note];
      }

      if (!this.notesByDate[formattedEventDate].find(noteByDate => noteByDate.id === note.id)) {
        this.notesByDate[formattedEventDate] = [...this.notesByDate[formattedEventDate], note];
      }
    }); // Note: Add markup for notes on each given date

    const noteDates = Object.keys(this.notesByDate);
    noteDates.forEach(date => {
      const formattedDate = (0, _moment.default)(date).format(this.dateFormat);
      const numberOfNotes = this.notesByDate[date].length;

      const noteHintMarkup = _markupBuilders.default.noteHint(formattedDate, numberOfNotes);

      const child = document.querySelector(`[data-date="${formattedDate}"]`)?.firstChild;
      const noteHintElement = this.calendarMarkup.insertMarkup(_markup.MarkupInsertionType.Prepend, child, noteHintMarkup);
      noteHintElement.setAttribute('class', monthViewElementClass);
    });
  }

  function _generatePostContent2(event) {
    const eventContentWrapper = document.createElement('div');
    const postTimeContainer = document.createElement('div');
    const postContentContainer = document.createElement('div');
    const postIconContainer = document.createElement('div');
    const postElements = {
      postTimeContainer,
      postContentContainer,
      postIconContainer,
      eventContentWrapper
    };
    this.calendarMarkup.updateCommonPostMarkup(postElements, event);
    eventContentWrapper.appendChild(postTimeContainer);
    eventContentWrapper.appendChild(postContentContainer);
    eventContentWrapper.appendChild(postIconContainer);
    return eventContentWrapper;
  }

  function _generateTimeSlotContent2(start) {
    const eventContentWrapper = document.createElement('div');

    const eventTime = _moment.default.tz(start, this.timeZoneIdentifier).format('h:mm');

    const timeSlotTimeContainer = document.createElement('div');
    timeSlotTimeContainer.innerHTML = `<div class='fc-event-time'>${eventTime}</div>`;
    const timeSlotContentContainer = document.createElement('div');
    eventContentWrapper.classList.add('fc-slot');

    const timeSlotMarkup = _markupBuilders.default.timeSlot();

    this.calendarMarkup.insertMarkup(_markup.MarkupInsertionType.Append, timeSlotContentContainer, timeSlotMarkup);
    eventContentWrapper.appendChild(timeSlotTimeContainer);
    eventContentWrapper.appendChild(timeSlotContentContainer);
    return eventContentWrapper;
  }

  function _getDroppedEventDateTime2(date) {
    const now = (0, _moment.default)();
    const dateForView = this.isOnMonthView ? new Date(_moment.default.tz(date, this.timeZoneIdentifier).hour(12).format()) : date;
    const isPastDate = now.isAfter(dateForView);
    const dateTimeInMilliseconds = isPastDate ? new Date(now.format()).getTime() : dateForView.getTime();
    return dateTimeInMilliseconds / 1000;
  }

  function _getDateWithTimeZone2(date) {
    return _moment.default.tz(date.toISOString(), this.timeZoneIdentifier);
  }

  function _handleDrop2(_ref13) {
    let {
      date,
      draggedEl
    } = _ref13;
    this.displayContextMenu = false;
    const {
      canDropOnCalendar,
      disableDrop,
      selectedAssets = []
    } = this.args;
    const multipleSelectedAssets = selectedAssets.length > 1;

    const scheduledTime = _classPrivateMethodGet(this, _getDroppedEventDateTime, _getDroppedEventDateTime2).call(this, date);

    const {
      mediaItemId
    } = draggedEl.dataset;

    if (!canDropOnCalendar || disableDrop) {
      return false;
    }

    if (multipleSelectedAssets) {
      this.segment.track('attempted-multi-photo-post');
    }

    if (!this.canCarousel && multipleSelectedAssets) {
      _classPrivateMethodGet(this, _displayCarouselWarning, _displayCarouselWarning2).call(this);

      return false;
    }

    if (!this.multipleProfilesSelected && this.socialProfile?.isTiktokUnverifiedAccount) {
      this.openTiktokRefreshModal(this.socialProfile);
      return false;
    }

    if (mediaItemId) {
      if (mediaItemId === 'text') {
        _classPrivateMethodGet(this, _trackSchedulingPost, _trackSchedulingPost2).call(this, 'empty_post');

        const singleOrMultiPost = this.multipleProfilesSelected ? _constants.ProfilePostType.Multi : _constants.ProfilePostType.Single;
        this.router.transitionTo(`cluster.schedule.calendar.post.${singleOrMultiPost}`, _constants.TEXT_POST_TYPE, {
          queryParams: {
            scheduledTime
          }
        });
        return;
      }

      if (this.multipleProfilesSelected && selectedAssets.length <= 1) {
        _classPrivateMethodGet(this, _transitionToMultiPostCreation, _transitionToMultiPostCreation2).call(this, mediaItemId, scheduledTime);
      } else if (this.canCarousel && multipleSelectedAssets) {
        _classPrivateMethodGet(this, _createCarouselPost, _createCarouselPost2).call(this, scheduledTime, mediaItemId, selectedAssets);
      } else {
        _classPrivateMethodGet(this, _createPost, _createPost2).call(this, mediaItemId, scheduledTime);
      }

      const isTestImage = draggedEl.hasAttribute('data-media-item-is-test-image');
      const mediaType = isTestImage ? _constants.TEST_IMAGE_MEDIA_TYPE : this.store.peekRecord('media-item', mediaItemId)?.mediaType;

      _classPrivateMethodGet(this, _trackSchedulingPost, _trackSchedulingPost2).call(this, mediaType || '');
    }
  }

  function _handleRightClick2(info) {
    const isRightClick = info.jsEvent.button === 2;
    const isCtrlClick = info.jsEvent.button === 0 && info.jsEvent.ctrlKey === true;

    if (isRightClick || isCtrlClick) {
      info.jsEvent.preventDefault();
      this.menuLeft = info.jsEvent.pageX;
      this.menuTop = info.jsEvent.pageY;
      this.selectedNoteDate = _moment.default.tz(info.dateStr, this.timeZoneIdentifier);
      this.displayContextMenu = true;
    }
  }

  function _isValidTimeSlotTarget2(classList) {
    return classList.contains('fc-bg-event') || classList.contains('fc-timegrid-event-harness') || classList.contains('fc-timegrid-now-indicator-container');
  }

  function _setEventsDisplay2(events, displayType) {
    events.forEach(event => {
      if (event.extendedProps.eventType !== POST) {
        event.setProp('display', displayType);
      }
    });
  }

  function _trackLastClick2(_ref14) {
    let {
      date,
      jsEvent,
      view
    } = _ref14;

    if (!date || !jsEvent || !view) {
      return;
    }

    this.lastClickInfo = {
      date,
      target: jsEvent.target,
      view: view.type
    };
  }

  function _transitionToMultiPostCreation2(mediaItemId, scheduledTime) {
    performance.mark('BeginPostV2');
    this.router.transitionTo('cluster.schedule.calendar.post.multi', mediaItemId, {
      queryParams: {
        scheduledTime,
        calendarDrop: true
      }
    });
  }

  function _transitionToPostCreation2(mediaItemId, scheduledTime) {
    performance.mark('BeginPostV2');
    this.router.transitionTo('cluster.schedule.calendar.post.new', mediaItemId, {
      queryParams: {
        scheduledTime,
        calendarDrop: true
      }
    });
  }

  function _turnOnCalendarNotes2() {
    this.showCalendarNotes = true;
    this.cache.add(this.calendarNotesCacheKey, this.showCalendarNotes, {
      expiry: this.cache.maxExpiryDate(),
      persist: true
    });
  }

  function _updateEventDisplay2() {
    const {
      fullCalendar
    } = this.calendarConfig;
    const events = fullCalendar?.getEvents();

    if (events && this.isOnMonthView) {
      _classPrivateMethodGet(this, _setEventsDisplay, _setEventsDisplay2).call(this, events, 'none');
    }
  }

  function _updateNoteTime2(event) {
    if (!event.start) {
      return this.errors.log('FullCalendar: Event start not provided to updateNoteTime');
    }

    const date = _classPrivateMethodGet(this, _getDateWithTimeZone, _getDateWithTimeZone2).call(this, event.start);

    this.calendarNote.update(event.id, date.unix());
  }

  function _trackSchedulingPost2(type) {
    this.segment.track('started-scheduling-post', {
      area: 'dragged_from_side_library_to_calendar',
      type,
      is_multi_profile: this.socialProfilesSelectedForScheduling.length > 1,
      multi_profile_types: this.socialProfilesSelectedForScheduling
    });
  }

  async function _updateTimeSlotTime2(event) {
    if (!event.start) {
      return this.errors.log('FullCalendar: Event start not provided to updateTimeSlotTime');
    }

    if (!this.multipleProfilesSelected) {
      const date = _classPrivateMethodGet(this, _getDateWithTimeZone, _getDateWithTimeZone2).call(this, event.start);

      await this.calendarTimeSlot.update(event.id, date);
      this.updateEvents();
    }
  }

  function _updateBttp2() {
    if (!this.bttp.toggledOn && this.bttp.couldShow) {
      this.bttp.autoEnableBttp.perform();
    }
  }

  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, FullCalendarComponent);
});